<template>
  <el-row class="bdb">
    <el-col :sm="{ span: 4, push: 2 }" :xs="{ span: 24 }">
      <div @click="$router.push({ name: 'index' })" class="comp-header_logo"></div>
    </el-col>
  </el-row>
</template>

<script>
import { getToken } from '../../service/helper';

export default {
  data() {
    return {
      token: getToken()
    };
  }
};
</script>

<style lang="scss">
.comp-header_logo {
  background-image: url(../../assets/images/logo.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 90px;
  cursor: pointer;
}
</style>
